import React from 'react';
import { SettingsBoxRowWrapper } from './SettingsBoxRowWrapper';

export const StripeSettingsBoxRowWrapper = ({
  children
}: {
  children: JSX.Element;
}): JSX.Element => {
  return <SettingsBoxRowWrapper label="Stripe">{children}</SettingsBoxRowWrapper>;
};
